import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnimatedSection from '../components/AnimatedSection';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Package, Building2, Phone, Mail } from 'lucide-react';

const OrderNowPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-4xl mx-auto">
                <h1 className="text-4xl lg:text-5xl font-bold mb-6" style={{ color: '#214140' }}>
                  Order Cordflex®
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  Ready to bring Cordflex to your facility? Whether you need a sample pack to evaluate
                  or a full case for your unit, we're here to help you get started.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </section>

        {/* Available Products Section */}
        <section className="py-20" style={{ backgroundColor: '#DFEAF0' }}>
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center mb-16">
                <h2 className="text-3xl lg:text-4xl font-bold mb-4" style={{ color: '#214140' }}>
                  Available Products
                </h2>
                <p className="text-xl text-gray-600">
                  Choose the right option for your needs
                </p>
              </div>
            </AnimatedSection>

            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              {/* Sample Pack */}
              <AnimatedSection animation="fade-up" delay={100}>
                <Card className="bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden h-full">
                  <div className="aspect-[4/3] overflow-hidden bg-gray-100 flex items-center justify-center">
                    <img
                      src="/images/products/White Cordflex on Bedrail - Both Sides 1.jpeg"
                      alt="Cordflex Sample Pack"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <CardContent className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <Package className="h-5 w-5" style={{ color: '#214140' }} />
                      <h3 className="text-xl font-bold" style={{ color: '#214140' }}>Sample Pack</h3>
                    </div>
                    <p className="text-gray-600 mb-4">
                      Perfect for evaluation. Try Cordflex on your unit before committing to a larger order.
                      Includes clips and setup instructions.
                    </p>
                  </CardContent>
                </Card>
              </AnimatedSection>

              {/* Full Case */}
              <AnimatedSection animation="fade-up" delay={200}>
                <Card className="bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden h-full">
                  <div className="aspect-[4/3] overflow-hidden bg-gray-100 flex items-center justify-center">
                    <img
                      src="/images/products/adapter-bulk.jpeg"
                      alt="Cordflex Full Case"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <CardContent className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <Building2 className="h-5 w-5" style={{ color: '#214140' }} />
                      <h3 className="text-xl font-bold" style={{ color: '#214140' }}>Full Case</h3>
                    </div>
                    <p className="text-gray-600 mb-4">
                      Ready for unit-wide implementation. Outfit your ICU with Cordflex clips for every bed.
                      Bulk pricing available for multi-unit orders.
                    </p>
                  </CardContent>
                </Card>
              </AnimatedSection>
            </div>
          </div>
        </section>

        {/* Order Now CTA Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-3xl mx-auto">
                <h2 className="text-3xl lg:text-4xl font-bold mb-6" style={{ color: '#214140' }}>
                  Ready to Get Started?
                </h2>
                <p className="text-xl text-gray-600 mb-4 leading-relaxed">
                  Contact us directly for pricing, availability, and to place your order.
                  Our team will work with you to find the right solution for your facility — whether
                  that's a sample pack for evaluation or a full deployment across multiple units.
                </p>
                <p className="text-lg text-gray-500 mb-10">
                  You can also reach out to one of our authorized distribution partners to get Cordflex
                  through your existing supply chain.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button
                    onClick={() => window.location.href = '/contact'}
                    size="lg"
                    className="px-8 py-4 text-lg font-semibold hover:opacity-90 transition-all duration-200 transform hover:scale-105"
                    style={{ backgroundColor: '#214140', color: 'white' }}
                  >
                    <Mail className="h-5 w-5 mr-2" />
                    Contact Us to Order
                  </Button>
                  <Button
                    onClick={() => window.location.href = '/find-distributor'}
                    variant="outline"
                    size="lg"
                    className="px-8 py-4 text-lg font-semibold border-2 hover:bg-teal-50 transition-all duration-200 transform hover:scale-105"
                    style={{ borderColor: '#214140', color: '#214140' }}
                  >
                    <Building2 className="h-5 w-5 mr-2" />
                    Find a Distributor
                  </Button>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </section>

        {/* Phone CTA 
        <section className="py-12" style={{ backgroundColor: '#214140' }}>
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center">
                <p className="text-white text-lg mb-3">
                  Prefer to talk? Give us a call.
                </p>
                <a
                  href="tel:+14100354089"
                  className="inline-flex items-center text-2xl font-bold text-white hover:opacity-80 transition-opacity"
                >
                  <Phone className="h-6 w-6 mr-3" />
                  (410) 935-4089
                </a>
              </div>
            </AnimatedSection>
          </div>
        </section>*/}
      </main>
      <Footer />
    </div>
  );
};

export default OrderNowPage;
